import React, { useEffect } from 'react'
import { Grid, PrimaryButton, Text } from '@moonpig/launchpad-components'
import {
  createGenericImpressionEvent,
  trackGAEvent,
} from '@moonpig/web-core-analytics'
import { useLocaleText } from '../../locale'
import { useChatModeContext } from '../../ChatContext'
import { StyledContainer, StyledIllustration } from './styled'

export const ErrorScreen = () => {
  const { hideChatModal } = useChatModeContext()
  const t = useLocaleText()

  useEffect(() => {
    trackGAEvent(
      createGenericImpressionEvent({
        category: 'ai concierge',
        action: 'error state',
        label: 'onload',
      }),
    )
  }, [])

  const handleClose = () => {
    hideChatModal()
  }

  return (
    <StyledContainer>
      <StyledIllustration />
      <Grid gap={4} marginTop={8}>
        <Text typography="typeDisplay01" as={'div'}>
          {t('concierge_error_screen.title')}
        </Text>
        <Text typography="typeBodyLead" as={'div'}>
          {t('concierge_error_screen.text')}
        </Text>
      </Grid>
      <PrimaryButton
        marginTop={8}
        onClick={handleClose}
        width="100%"
        aria-label={t('concierge_error_screen.close_button_aria_label')}
      >
        {t('concierge_error_screen.close_button')}
      </PrimaryButton>
    </StyledContainer>
  )
}
